import React from "react";
import { useNavigate } from "react-router-dom";

import { myCustomTheme } from "../Theme";

import headerData from "../Json/PageHeaderData.json";

import "../Style/PageHeader.css";

const theme = myCustomTheme;

const PageHeader = ({ pageKey = "about" }) => {

    const navigate = useNavigate();

    const data = headerData[pageKey];

    return (

        <section
            className="page-header-section"
            style={{
                background: `
                    linear-gradient(
                        135deg,
                        ${theme.colors.bg_primary} 0%,
                        ${theme.colors.header_footer_bg} 50%,
                        ${theme.colors.bg_secondary} 100%
                    )
                `,
            }}
        >

            <div className="page-header-container">

                {/* TITLE */}

                <h1
                    className="page-header-title"
                    style={{
                        color: theme.colors.heading,
                        fontFamily: theme.typography.heading_font,
                    }}
                >
                    {data.title}
                </h1>

                {/* BREADCRUMB */}

                <div
                    className="page-header-path"
                    style={{
                        fontFamily: theme.typography.text_font,
                        color: theme.colors.menu_text,
                    }}
                >

                    <span
                        className="home-link"
                        onClick={() => navigate("/")}
                    >
                        Home
                    </span>

                    <span
                        style={{
                            color: theme.colors.menu_text,
                        }}
                    >
                        /
                    </span>

                    <span
                        style={{
                            color: theme.colors.heading,
                            fontWeight: 600,
                        }}
                    >
                        {data.title}
                    </span>

                </div>

            </div>

        </section>
    );
};

export default PageHeader;